import { Checkbox, Input, message, Modal } from "antd";
import Title from "antd/es/typography/Title";
import { useEffect, useState } from "react";
import { post, put } from "~/Services";
import { useNotification } from "@hooks/useNotification";
import { SuccessModal } from "@components/SuccessModal/SuccessModal";
import TextArea from "antd/lib/input/TextArea";
import { useQuery } from "~/Hooks/useQuery";

interface ApprovalModalProps {
  id: string;
  openModal: boolean;
  Signing: (arg: any) => void;
  handlePlaceHolder: (arg: any) => void;
  commentModal: boolean;
  name: string;
  handleSending?: (arg: any) => void;
  sendModal?: boolean;
  handleReject?: (arg: any) => void;
  handleCancel?: (arg: any) => void;
  openRejectModal?: boolean;
  openCancelModal?: boolean;
  reTrigger?: (arg: any) => void;
  type?: "comment" | "placeholder" | "send";
  openSendingModal?: boolean;
}

export const ApprovalModal: React.FC<ApprovalModalProps> = ({
  id,
  openModal,
  Signing,
  commentModal,
  handlePlaceHolder,
  handleSending,
  name,
  handleReject,
  handleCancel,
  openRejectModal,
  openCancelModal,
  sendModal,
  reTrigger,
  type,
  openSendingModal,
}) => {
  const [open, setOpen] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);
  const [consoleViewErrOpen, setConsoleViewErrOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [url, setUrl] = useState("");
  const [urlCheckbox, setUrlCheckbox] = useState(false);
  const [verifyCheckbox, setVerifiedCheckbox] = useState(false);
  const [expiryTime, setExpiryTime] = useState<any>();
  const [currentTime, setCurrentTime] = useState<any>();
  const [timeDifference, setTimeDifference] = useState(0);
  const [rejectReason, setRejectReason] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const { openNotification } = useNotification();
  const query=useQuery();
  const activeQuery = query.get("enable");

  useEffect(() => {
    if (openSendingModal) {
      setOpen(openModal || commentModal || openSendingModal);
    } else if (openRejectModal) {
      setOpen(openRejectModal);
    }else if(openCancelModal){
      setOpen(openCancelModal)
    } else {
      setOpen(openModal || commentModal);
    }
  }, [openModal, commentModal, openSendingModal, openRejectModal,openCancelModal]);

  const handleSigning = async () => {
    const formData = new FormData();
    formData.append("envelopeId", id);
    setLoading(true);
    put("v1/workflow/approve", formData)
      .then((res: any) => {
        Signing(true);
        setSuccessOpen(true);
        setLoading(false);
        setOpen(false);
        closeModal();
      })
      .catch((err) => {
        setLoading(false);
        setOpen(false);
        Signing(false);
        message.error(err);
        closeModal();
      });
  };

  const [cancelStatus, setCancelStatus] = useState();

  const handleCancelling = async () => {
    const formData = {
      envelopeId: id,
      comment: cancelReason,
      ...(activeQuery === "return" && { cancelledByWatcher: true }),
    };
    setLoading(true);
    put("v1/workflow/cancel", formData)
      .then((res: any) => {
        setCancelStatus(res);
        Signing(true);
        setSuccessOpen(true);
        setLoading(false);
        setOpen(false);
        closeModal();
      })
      .catch((err) => {
        setLoading(false);
        setOpen(false);
        Signing(false);
        message.error(err);
        closeModal();
      });
  };

  const [rejectStatus, setRejectStatus] = useState();

  const handleRejection = async () => {
    const formData = {
      envelopeId: id,
      comment: rejectReason,
    };
    setLoading(true);
    put("v1/workflow/reject", formData)
      .then((res: any) => {
        setRejectStatus(res);
        Signing(true);
        setSuccessOpen(true);
        setLoading(false);
        setOpen(false);
        closeModal();
      })
      .catch((err) => {
        setLoading(false);
        setOpen(false);
        Signing(false);
        message.error(err);
        closeModal();
      });
  };

  const handleSigningComment = () => {
    const formData = new FormData();
    formData.append("envelopeId", id);
    formData.append("returnUrl", window.location.href);
    setLoading(true);
    post("v1/clm/createConsoleView ", formData)
      .then((res: any) => {
        handlePlaceHolder(true);
        setLoading(false);
        setOpen(false);
        setUrl(res?.response?.data);
        window.location.replace(res?.response?.data);
        closeModal();
      })
      .catch((err) => {
        setExpiryTime(err.response.data.expiryTime);
        setCurrentTime(err.response.data.currentTime);
        setConsoleViewErrOpen(true);
        handlePlaceHolder(false);
        setLoading(false);
        setOpen(false);
        closeModal();
      });
  };

  const handleSendSigning = () => {
    const formData = new FormData();
    formData.append("envelopeId", id);
    formData.append("status", "sent");
    setLoading(true);
    put("v1/workflow/deleteLock", formData)
      .then((res: any) => {
        put("v1/clm/update/envelope-status", formData)
          .then((res) => {
            setLoading(false);
            setOpen(false);
            setSuccessOpen(true);
          })
          .catch((err) => {
            openNotification({
              title: " Please ensure that you have placed all the required Placeholders for Signature",
              message: "",
              type: "error",
            });
            setLoading(false);
            setOpen(false);
            closeModal();
          });
      })
      .catch((err: any) => {
        setLoading(false);
        closeModal();
      });
  };

  const closeModal = () => {
    handlePlaceHolder(false);
    setOpen(false);
    Signing(false);
    setUrlCheckbox(false);
    setVerifiedCheckbox(false);
    setRejectReason("");
    setCancelReason("")
    if (handleSending) {
      handleSending(false);
    }
    if (handleReject) {
      handleReject(false);
    }
    if(handleCancel){
      handleCancel(false)
    }
  };

  return (
    <>
      <Modal
        open={open}
        maskClosable={false}
        centered
        closable={false}
        bodyStyle={{ maxHeight: 500, overflowY: "auto" }}
        onCancel={() => closeModal()}
        okText={commentModal ? "Yes" : openSendingModal ? "Yes" : "Yes"}
        confirmLoading={loading}
        onOk={() => {
          commentModal
            ? handleSigningComment()
            : openSendingModal
            ? handleSendSigning()
            : openRejectModal
            ? handleRejection()
            : openCancelModal ? handleCancelling() : handleSigning()
        }}
        okButtonProps={{
          disabled: openSendingModal ? !(urlCheckbox && verifyCheckbox) : openRejectModal ? !rejectReason : openCancelModal ?  !cancelReason : false,
        }}
      >
        <div>
          <p>
            <Title level={5}>
              {openRejectModal
                ? `Are you sure to reject ${name} contract?`
                : commentModal
                ? "You are about to be redirected to the DocuSign website. Do you wish to proceed?"
                : openSendingModal
                ? "Are you sure to send for Signing"
                : openCancelModal ? `Are you sure to cancel ${name} contract?`  : `Are you sure to approve ${name} contract?`}
            </Title>
            {openSendingModal ? (
              <>
                <Checkbox
                  style={{ marginBottom: "10px", marginTop: "10px" }}
                  checked={urlCheckbox}
                  onChange={(value: any) => {
                    setUrlCheckbox(value?.target?.checked);
                  }}
                >
                  I have placed all the required Sign holders in Document
                </Checkbox>
                <Checkbox
                  style={{ marginLeft: 0 }}
                  checked={verifyCheckbox}
                  onChange={(value: any) => {
                    setVerifiedCheckbox(value?.target?.checked);
                  }}
                >
                  I have verified the position of all the Sign holders
                </Checkbox>
              </>
            ) : openRejectModal ? (
              <>
                <TextArea
                  maxLength={5000}
                  showCount
                  placeholder="Please provide a reason for rejection"
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                />
              </>
            ) : openCancelModal ? (
              <>
              <TextArea
                maxLength={5000}
                showCount
                placeholder="Please provide a reason for cancel"
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
              />
            </>
            ):("")}
          </p>
        </div>
      </Modal>
      <SuccessModal
        title={"Unable to Open Envelope - Concurrent Access"}
        message={`We encountered an issue while trying to open this envelope. It appears another user has already accessed it. To maintain data integrity and prevent conflicts, envelopes can only be viewed by one user at a time. The envelope will likely be available for you to open after 20 minutes.`}
        type={"info"}
        buttonText={"Go Back"}
        redirect={""}
        open={consoleViewErrOpen}
        setOpen={setConsoleViewErrOpen}
        // reTrigger={reTrigger}
      />
      <SuccessModal
        message={""}
        title={
          rejectStatus
            ? `You have successfully rejected ${name} contract`
            : commentModal
            ? `You have successfully sent the ${name} contract for signing`
            : openSendingModal
            ? `You have successfully sent the ${name} contract for signing`
            : cancelStatus ? `You have successfully cancelled ${name} Contract` : `You have successfully approved ${name} Contract`
        }
        type={"success"}
        buttonText={"Go Back"}
        redirect={""}
        open={successOpen}
        setOpen={setSuccessOpen}
        reTrigger={reTrigger}
      />
    </>
  );
};
